<script setup>

import { ref, computed, onBeforeUnmount, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTranslaterStore } from '@/stores/translater'

const emit = defineEmits(['get-token', 'error'])

const authStore = useAuthStore()
const translaterStore = useTranslaterStore()

const scriptUrl = 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload'
const keyClient = 'ysc1_TvAiphdRqIQUT6ege5a8aoXYgsAzqnv5nW9P7mHs2a00adff'
const widgetId = ref(null)
const script = ref(null)

const smartCaptchaScript = computed(() => authStore.smartCaptchaScript)
const getTranslate = computed(() => translaterStore.getTranslate)

function createScript() {
    script.value = document.createElement('script')
    script.value.src = scriptUrl

    script.value.onload = async () => {
        initSmartCaptcha()
    }

    script.value.onerror = async () => {

        emit('error', getTranslate.value.SMART_CAPTCHA_ERROR_LOAD + ' ' + script.value.src)
    }

    document.head.appendChild(script.value)

    authStore.setSmartCaptchaScript(true)
}

function initSmartCaptcha() {

    if (window.smartCaptcha) {

        const container = document.getElementById('captcha-container')

        widgetId.value = window.smartCaptcha.render(container, {
            // hl: 'ru',
            // test: true,
            sitekey: keyClient,
            invisible: true,
            hideShield: true,
            shieldPosition: 'top-right', // `top-left` | `center-left` | `bottom-left` | `top-right` | `center-right` | `bottom-right`
            callback: getToken
        })

        authStore.setSmartCaptchaId(widgetId.value)

        // События каптчи
        window.smartCaptcha.subscribe(widgetId.value, 'javascript-error', (error) => {
            emit('error', getTranslate.value.SMART_CAPTCHA_ERROR_JS + ': ' + error)
        })

        window.smartCaptcha.subscribe(widgetId.value, 'network-error', () => {
            emit('error', getTranslate.value.SMART_CAPTCHA_ERROR_NETWORK)
        })
    }
}

function getToken(token) {

    emit('get-token', token)
}

onMounted(() => {

    if (!smartCaptchaScript.value) {

        createScript()
    } else {

        initSmartCaptcha()
    }
})

onBeforeUnmount(() => {

    if(typeof widgetId.value === 'number') {

        // Удалить каптчу
        authStore.setSmartCaptchaId(null)

        setTimeout(() => {
            window.smartCaptcha.destroy(widgetId.value)
        }, 0)

    } else if(smartCaptchaScript.value) {

        // Удалить не загрузившийся скрипт
        script.value.remove()

        authStore.setSmartCaptchaScript(false)
    } 
}) 

</script>

<template>
    <div class="uta-smart-captcha mb-3">
        <div class="smart-captcha-policy uta-smart-captcha__policy">{{ getTranslate.SMART_CAPTCHA_POLICY }} <a href="https://yandex.ru/legal/smartcaptcha_notice/" target="_blank" class="uta-smart-captcha__policy-link">Yandex SmartCaptcha</a></div>
        <div id="captcha-container" class="smart-captcha uta-smart-captcha__container"></div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/smart-captcha.scss';
</style>